export enum QuizType {
    QuizQ = "Quiz",
    SurveyA = "Medical History",
    SurveyB = "Habits",
}